import Config from '../config'
import { getDeviceId } from './helpers'

export const serializeLogEntry = (message, context) => {
  return {
    _msg: message,
    ...context,
    service: 'audience',
    env: Config.env,
    localTime: new Date().toISOString(),
    deviceId: getDeviceId(),
  }
}

export const isRemoteSupported = () => {
  return !!process.env.VUE_APP_REMOTE_LOG_URL && !!process.env.VUE_APP_REMOTE_LOG_AUTH
}

export const flushLogToRemote = async (lines) => {
  try {
    if (!isRemoteSupported()) {
      return
    }
    const body = lines.map((line) => JSON.stringify(line)).join('\n')
    const auth = process.env.VUE_APP_REMOTE_LOG_AUTH

    const response = await fetch(`${process.env.VUE_APP_REMOTE_LOG_URL}?_stream_fields=service,env`, {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/stream+json',
        Authorization: `Basic ${auth}`,
      },
      body,
      // allow the request to outlive the page
      keepalive: true,
    })

    if (!response.ok) {
      const errorText = await response.text()
      // eslint-disable-next-line no-console
      console.error('Failed to flush log to remote:', response.status, errorText)
    }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Error flushing log to remote:', error)
  }
}
